import { createSelector } from 'reselect';

import type { State } from 'reducers';

import type { LocalSettingsMutable, LocalSettingsState } from './reducer';

export const selectLocalSettings = (state: State): LocalSettingsState => state.get('localSettings');

// @ts-expect-error @NOTE-AC: This shows a typescript error, but it is the correct type! Not sure how to implement this properly
export const selectLocalSetting: <T extends keyof LocalSettingsMutable>(
  state: State,
  key: T
) => LocalSettingsMutable[T] = createSelector(
  selectLocalSettings,
  (_settings: LocalSettingsState, key: keyof LocalSettingsMutable) => key,
  (settings: LocalSettingsState, key: keyof LocalSettingsMutable) => settings.get(key)
);
